import {
  AnimationProvider,
  Button,
  Card,
  LoadingAlert,
  WarningAlert,
} from '@/components';
import TradeButton from '@/components/organisms/Trade/TradeButton';
import { useMarketData } from '@/components/providers';
import { URLS } from '@/utils/constants';
import { useRouter } from 'next/router';
import { FC } from 'react';
import MarketTopAssetsList from './MarketTopAssetsList';
interface Props {
  className?: string;
  limit?: number;
  showAllDetails?: boolean;
  showSomeDetails?: boolean;
  rightAlignLastColumn?: boolean;
}
const visualizeElementsAndSpacing = false;
const borderClassToVisualizeElementsAndSpacing = visualizeElementsAndSpacing
  ? 'border-white border'
  : '';
const spacingConfig = {
  rootGap: 'gap-sm',
};
const sizingConfig = {
  rootHeight: 'min-h-40',
};
const MarketTopAssetsCard: FC<Props> = ({
  className,
  limit = 100,
  showAllDetails = true,
  showSomeDetails = false,
  rightAlignLastColumn = false,
}) => {
  const { globalMarketData, isLoading, error } = useMarketData();
  const router = useRouter();
  const handleSeeAllAssets = () => {
    router.push(URLS.allMarketData);
  };
  const MarketTopAssetsCardHeader: FC = () => {
    return (
      <Card.Header
        title={`Market`}
        loading={isLoading}
        right={
          <>
            {showAllDetails && (
              <AnimationProvider key="trade-animation">
                <TradeButton key="trade-button" />
              </AnimationProvider>
            )}
            {globalMarketData.length > 0 && limit < globalMarketData.length && (
              <Button intent="ghost" onClick={handleSeeAllAssets}>
                See all
              </Button>
            )}
          </>
        }
      />
    );
  };
  const MarketTopAssetsCardBody: FC = () => {
    if (isLoading && globalMarketData.length === 0) {
      return (
        <LoadingAlert
          title="Market data is being fetched."
          description="Please wait while we fetch the latest market data."
        />
      );
    }
    if (!isLoading && globalMarketData.length === 0) {
      return (
        <WarningAlert
          title="No market data was found."
          description="We couldn't find any market data at the moment. Please try again later."
        />
      );
    }
    if (error) {
      return (
        <WarningAlert
          title="Error loading market data."
          description={error.message}
        />
      );
    }
    return (
      <Card.Body>
        <div
          className={`flex flex-col 
            ${spacingConfig.rootGap} 
            ${sizingConfig.rootHeight} 
            ${borderClassToVisualizeElementsAndSpacing}`}
        >
          <MarketTopAssetsList
            limit={limit}
            showAllDetails={showAllDetails}
            showSomeDetails={showSomeDetails}
            rightAlignLastColumn={rightAlignLastColumn}
          />
        </div>
      </Card.Body>
    );
  };
  return (
    <Card className={className}>
      <MarketTopAssetsCardHeader />
      <MarketTopAssetsCardBody />
    </Card>
  );
};
export default MarketTopAssetsCard;
